// extracted by mini-css-extract-plugin
module.exports = {"titol":"IntroduccioTitolClasse_titol__3ogHY"};